import React, { FC } from 'react';
import styles from './modal_confirmation_content.module.scss';

export const ModalConfirmationContent: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
